module.exports = __webpack_public_path__ + "media/TheVeryLastPizzaDemo.15099f65.mp4";